/*
 * File: alphaTheme.js
 * Project: reports
 * Created Date: Thursday August 2nd 2018
 * Author: Austin Smith
 * -----
 * Last Modified: Tuesday, 11th September 2018 6:06:44 am
 * Modified By: Austin Smith (austin.smith918@yahoo.com>)
 * -----
 * Copyright (c) 2018 Teaming
 */

export default {
    primary: "#5DC8E0",
    secondary: "#2695AD",
    accent: "#0F677A",
    error: "#FF3739",
    info: "#00D0BD",
    success: "#00D014",
    warning: "#FFB70F",
};



// WEBPACK FOOTER //
// ./src/themes/alphaTheme.js